'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.colorScale = colorScale;

var _d3Scale = require('d3-scale');

function colorScale(i) {
	return _d3Scale.schemeCategory20c[i % 20];
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/charts/scales.js
// module id = 563
// module chunks = 0